import type { LockBadgeProps } from './LockBadge';

/** The tooltip / accessible name of a lock badge. */
export function lockBadgeLabel(props: Pick<LockBadgeProps, 'state' | 'by' | 'reason'>): string {
    if (props.reason) return props.reason;
    if (props.state === 'inherited') return props.by ? `Locked through “${props.by}”` : 'Locked through a parent page';
    return 'Locked';
}
